export const TakeHtmlSnapshot = 'sos.Html.TakeHtmlSnapshot';
export interface TakeHtmlSnapshot {
	type: typeof TakeHtmlSnapshot;
}

export const HtmlSnapshotTaken = 'sos.Monitoring.Html.HtmlSnapshotTaken';
export interface HtmlSnapshotTaken {
	type: typeof HtmlSnapshotTaken;
	html: string;
}
